const endpoint = "https://rvpb.cuba-lv.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = "https://s3-media.cuba-lv.com"

const gamePlace = { studio: "tbilisi", room: "po5-room" }
const name = "Vip Russian Poker"
const number = 1

export { endpoint, cpoint, mediapoint, gamePlace, name, number }
